/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';

import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';
import { NetworkManager } from '../../../core/network/NetworkManager';
import { RootState, useTivoDispatch, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { isHomeScreenCcbSwitchEnabled } from '../../../core/utils/ccb/CcbSwitchHelper';
import { showWhisper } from '../../../store/whisper/whisper.reducer';
import { AntiburnOsd, EmptyGuideMessage } from '../../common';
import { NoNetworkOverlay } from '../../NoNetworkOverlay';
import { SidebarNavigationMenu } from '../../SidebarNavigationMenu';
import { Whisper } from '../../Whisper';
import { WhisperTypes } from '../../Whisper/WhisperTypes';
import { GridGuideFooter } from '../GridGuideFooter';

import './EmptyGuide.scss';

const EmptyGuide: FunctionComponent = (): JSX.Element => {
    const { isActive: isAntiBurnOsdActive } = useTivoSelector(
        (state: RootState) => state.antiburnOsd,
    );

    const { channelsTypeIndex, categoriesTypeIndex } = useTivoSelector(
        (state: RootState) => state.channelOptionsOverlay,
    );

    const dispatch = useTivoDispatch();

    useEffect(() => {
        if (NetworkManager.isNetworkDisconnected()) {
            dispatch(
                showWhisper({
                    message: NetworkManager.getNetworkDisconnectedMessage(),
                    iconType: WhisperTypes.INFO,
                }),
            );
        }
    }, []);

    return (
        <React.Fragment>
            {!isHomeScreenCcbSwitchEnabled() && <SidebarNavigationMenu />}
            <div className="empty-guide-container">
                <EmptyGuideMessage />
                <GridGuideFooter
                    selectedCategoryType={Locale.getString(categoriesTypeIndex)}
                    selectedChannelType={Locale.getString(channelsTypeIndex)}
                    optionsMessage={Locale.getString(
                        LocaleKeys.GUIDE_SELECT_PRESS_AND_HOLD_MESSAGE,
                    )}
                    settingsMessageFirstPart={Locale.getString(
                        LocaleKeys.GUIDE_SETTINGS_MESSAGE_FIRST_PART,
                    )}
                    settingsMessageMiddlePart={Locale.getString(
                        LocaleKeys.GUIDE_SETTINGS_MESSAGE_MIDDLE_PART,
                    )}
                    settingsMessageLastPart={Locale.getString(
                        LocaleKeys.GUIDE_SETTINGS_MESSAGE_LAST_PART,
                    )}
                    menuMessage={Locale.getString(LocaleKeys.GUIDE_FOOTER_MENU_TEXT)}
                />
                {isAntiBurnOsdActive && <AntiburnOsd />}
                <NoNetworkOverlay />
                <Whisper message="" />
            </div>
        </React.Fragment>
    );
};

export default EmptyGuide;
